export default __webpack_public_path__ + "static/media/tennis-firstServe-thumbnail.c9d093a5.png";